import './assets/blk-loading.css';
import './assets/global.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import 'react-quill/dist/quill.snow.css';

import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import FormFieldsContext from '@react-form-fields/material-ui/components/Context';
import { antdTheme, theme } from 'assets/theme';
import { ConfigProvider } from 'antd';
import Pages from 'components/Pages';
import ColorPicker from 'components/Shared/ColorPicker';
import Loader from 'components/Shared/Loader';
import Toast from 'components/Shared/Toast';
import fieldConfig from 'fieldConfig';
import React from 'react';
import { setup } from 'rxjs-operators';
import GoogleMapsLib from './services/GoogleMapsLib';
import { ThemeProvider } from '@mui/styles';

export default class App extends React.PureComponent {
  loader = React.createRef<Loader>();
  formFieldConfig = fieldConfig;

  componentDidMount() {
    setup(this.loader.current);
    console.log('(Front) Version Number: 1094 / Branch: master / Commit: 4b0c9419ab');
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <ConfigProvider theme={antdTheme}>
            <FormFieldsContext config={this.formFieldConfig}>
              <CssBaseline />
              <GoogleMapsLib />
              <ColorPicker />
              <Loader innerRef={this.loader} />
              <Toast.Global />
              <Pages />
            </FormFieldsContext>
          </ConfigProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    );
  }
}
